<template>
  <div class="quotation">
    <van-nav-bar title="报价单" fixed />
    <van-tabs sticky offset-top="46px" v-model="curTab" @change="handleTabChange" animated swipeable>
      <van-tab v-for="tab in tabs" :title="tab.name" :name="tab.value" :key="tab.value">
    <van-list
      class="quotation-list"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell class="quotation-item" :border="false" v-for="item in list" :key="item.id" @click="toDetail(item)">
        <div class="flex-row-between">
          <div class="font-12 color-gray">{{ item.update_time | dateFormat }} <van-tag class="font-12 line-height-12" :type="item.status ? 'success' : 'warning'" plain>{{ item.quote_type_desc }}</van-tag></div>
          <span>{{ item.status_desc }}</span>
        </div>
        <div class="flex-row-between">
          <div class="font-14 font-weight-blod">{{ item.car_brand_name }} {{ item.product_time }} {{ item.displacement }}L</div>
          <div class="font-12 color-gray">{{ item.vin_code }}</div>
        </div>
        <div class="flex-row-between">
          <div class="font-12 ellipsis-line">{{ item.detailPartsName || '-' }}</div>
        </div>
        <div class="flex-row-between">
          <div class="font-12 color-gray">询单：{{ item.quote_order_no || '-' }}</div>
        </div>
        <div class="flex-row-between">
          <div class="font-12 color-gray flex-row">订单：<div class="flex1 inline-block ellipsis-line">{{ item.order_no || '-' }}</div></div>
        </div>
        <div class="flex-row-between">
          <div class="font-12 color-gray ellipsis-line">{{ item.corporation_name || '-' }}</div>
        </div>
      </van-cell>
    </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { queryQuoteList } from '@/api/quotation'
export default {
  name: 'Quotation',
  data() {
    return {
      tabs: [
        {
          name: '全部',
          value: ''
        },
        {
          name: '待报价',
          value: 0
        },
        {
          name: '已报价',
          value: 1
        },
        {
          name: '已接单',
          value: 2
        },
      ],
      curTab: '',
      list: [],
      loading: false,
      finished: false,
      page_dto: {
        pagination: 0,
        page_size: 20
      }
    }
  },
  created() {
    this.onRefresh()
  },
  methods: {
    // 刷新
    async onRefresh() {
      this.page_dto.pagination = 0
      this.finished = false
      const data = await this.search()
      this.list = data || []
      if (this.list.length < this.page_dto.page_size) {
        this.finished = true
      } else {
        this.page_dto.pagination++
      }
      this.loading = false
    },
    async search() {
      this.loading = true
      const { success, model, msg } = await queryQuoteList({status: this.curTab, page_dto: this.page_dto}).catch(() => {
        return []
      })

      if (!success) {
        this.$toast(msg || '请求失败')
        return []
      }
      if (!model) {
        return []
      }
      const innerModel = model.model
      let data

      if (!Array.isArray(innerModel)) {
        data = []
      } else {
        data = innerModel
      }

      data = data.map(item => {
        item.detailPartsName = Array.isArray(item.detail_parts_alias_list) ? item.detail_parts_alias_list.join('、') : ''
        return item
      })

      return data
    },
    handleTabChange() {
      this.onRefresh()
    },

    // 上拉加载
    async onLoad() {
      if (this.finished) return
      
      const data = await this.search()
      if (data.length < this.page_dto.page_size) {
        this.finished = true
      } else {
        this.page_dto.pagination++
      }
      this.$nextTick(() => {
        this.list = this.list.concat(data)
        
        this.loading = false
      })
    },
    toDetail(item) {
      const { quote_type_desc, id } = item
      const url = quote_type_desc === '人工报价' ? 'customQuotationDetail' : 'quotationDetail'
      this.$router.push(`/${url}/` + id.toString())
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variables.scss';
.quotation {
  background-color: #f7f7f7;
  box-sizing: border-box;
  // padding: 10px;
  height: 100%;
  .quotation-list {
    padding: 10px;
    .quotation-item {
      margin-top: 10px;
      border-radius: 10px;
      &:nth-child(1) {
        margin-top: 0;
      }
      .inline-block {
        max-width: 260px;
      }
    }
  }
}
</style>